import { useEffect, useState } from "react";
import { useTheme } from "../../../../components/hooks/useTheme";
import { useNavigate } from "react-router-dom";
import baseURL from "../../../../configs/api";
import axios from 'axios';
import { Button } from "@mui/material";
import Select from "react-select";
import PleaseWaitPopup from "../../../PleaseWaitPopup";
import colorConfigs from "../../../../configs/colorConfigs";
import useAuth from "../../../../components/hooks/useAuth";
import Cookies from "js-cookie";
import useTenant from "../../../../components/hooks/useTenant";

export const AddVehicleEngine = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const { themeStyles } = useTheme();
  const navigate = useNavigate();
  const [label, setLabel] = useState<string>("");
  const [vehicleModelId, setVehicleModelId] = useState<string>("");
  const [vehicleModelOptions, setVehicleModelOptions] = useState([]);
  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

  useEffect(() => {
    axios
      .get(`${baseURL}vehicleModel`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setVehicleModelOptions(() =>
          response.data.map((item: any) => {
            return { value: item.id, label: item.modelName };
          })
        );

        setVehicleModelId(response.data[0].id);
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setPleaseWaitPopup(true);

    await axios
      .post(
        `${baseURL}vehicleEngine?userId=${auth?.id}`,
        JSON.stringify({
          engineName: label,
          vehicleModelId
        }),
        {
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
          },
          withCredentials: true,
        }
      )
      .then((_) => {
        setPleaseWaitPopup(false);
        navigate(-1);
        handleTenantError(null);
      })
      .catch((error) => {
        setPleaseWaitPopup(false);
        handleTenantError(error);
      });
  };

  return (
    <>
      <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
          <div className="w-full mt-2">
            <div className={`w-full pb-4`}>

              <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                <div className="flex items-center gap-1.5">
                  <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Add Vehicle Engine</h2>
                </div>
              </div>

              <div className="mt-2 p-2">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="w-full px-2">
                    <div className="grid grid-cols-3 gap-6">
                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Label</label>
                          <input
                            type="text"
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={label}
                            onChange={(e) => setLabel(e.target.value)}
                            required
                          />
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Vehicle Model</label>
                          <Select
                            styles={{
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                backgroundColor: themeStyles.topBar.bg,
                                color: themeStyles.topBar.textColor,
                                borderRadius: '8px',
                                borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                                "&: hover": {
                                  borderColor: "#167AC3",
                                }

                              }),
                              menu: (base) => ({
                                ...base,
                                fontSize: "12px",
                                backgroundColor: themeStyles.topBar.bg,
                                color: themeStyles.topBar.textColor,
                              }),
                              option: (base, state) => {
                                const isSelected = state.isSelected;
                                const isFocused = state.isFocused;
                                const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                                const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                                const defaultTextColor = themeStyles.topBar.textColor || "#000";

                                return {
                                  ...base,
                                  backgroundColor: isSelected
                                    ? selectedBg
                                    : isFocused
                                      ? hoverBg
                                      : "transparent",
                                  color: isSelected ? "#fff" : defaultTextColor,
                                  fontWeight: 600,
                                  ':active': {
                                    backgroundColor: isSelected ? selectedBg : hoverBg,
                                  },
                                };
                              },
                              input: (base) => ({
                                ...base,
                                color: themeStyles.topBar.textColor,

                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: themeStyles.topBar.textColor,
                              }),
                            }}
                            className="basic-single"
                            classNamePrefix="select"
                            isDisabled={false}
                            isLoading={false}
                            isClearable={true}
                            isRtl={false}
                            isSearchable={false}
                            name="vehicleModel"
                            value={vehicleModelOptions.find(
                              (item: any) => item.value === vehicleModelId
                            )}
                            onChange={(vehicleModel: any) =>
                              setVehicleModelId(vehicleModel ? vehicleModel.value : "")
                            }
                            options={vehicleModelOptions}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="flex gap-4 mt-6">
                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.main.bg
                        }}
                        type="submit"
                      >
                        Save
                      </Button>

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.cancel.bg,
                          border: colorConfigs.btn.cancel.border,
                          color: colorConfigs.btn.cancel.color
                        }}
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  )
}
